import React from "react";
import ProductCard from "./ProductCard";

const Search = () => {
  return (
    <>
      <div className="tf-page-title">
        <div className="container-full">
          <div className="row">
            <div className="col-12">
              <div className="heading text-center">Search</div>
            </div>
          </div>
        </div>
      </div>
      <section className="flat-spacing-1">
        <div className="container-full">
          <div className="grid-layout wrapper-shop" data-grid="grid-4">
            <ProductCard />
            <ProductCard />
            <ProductCard />
            <ProductCard />
          </div>
        </div>
      </section>
    </>
  );
};

export default Search;
